import { combineReducers } from "redux";
import isFetching from "./isFetching";
import byId from "./byId";
import { ModuleMetadataSTORE } from "../../../types";

export default combineReducers<ModuleMetadataSTORE>({
  isFetching,
  byId,
});
